<template>
  <HeaderNavbar
    :title="$t('portfolio.list_poolmirror')"
    :breadcrumbs="[{ label: $t('nav.poolmirror_list'), path: { name: 'poolmirror.list' } }]" />
  <div class="container-lead">
    <div class="mt-4">
      <div class="responsive-padding row gap-4">
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 grid">
          <RouterLink
            v-for="portfolio in portfolios"
            :key="portfolio.campaign.name"
            :to="{ name: 'poolmirror.detail', params: { id: portfolio.campaign.id } }"
            v-slot="{ navigate }"
            custom>
            <div class="card m-0 nav-card selectable-card me-3" @click="navigate">
              <div class="card-body">
                <div class="d-flex flex-column justify-content-center align-items-center">
                  <h3 class="pt-1 text-nowrap fw-bold">{{ portfolio.campaign.name }}</h3>
                  <p class="text-muted m-0">{{ usedSlots(portfolio) }}</p>
                  <div class="mt-3">
                    <span class="status" :class="poolmirrorStore.statusColorClass(portfolio.campaign.status)">
                      <span class="status-dot status-dot-animated"></span>
                      {{ poolmirrorStore.statusString(portfolio.campaign.status) }}
                    </span>
                  </div>
                  <div v-tooltip="remainingDaysTooltip(portfolio)" class="progress progress-sm mt-3">
                    <div
                      class="progress-bar bg-primary"
                      :style="{ width: `${100 - poolmirrorStore.remainingDaysPercentage(portfolio.campaign)}%` }"></div>
                  </div>
                </div>
              </div>
            </div>
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import HeaderNavbar from '@/components/header/HeaderNavbar.vue';
import { useCustomerFeaturesStore } from '@/stores/customerFeatures';
import { usePoolmirrorStore } from '@/stores/poolmirror';
import translator from '@/locale/translator';

const featureStore = useCustomerFeaturesStore();
const poolmirrorStore = usePoolmirrorStore();
const portfolios = ref([] as any);

onMounted(async () => {
  await featureStore.fetchFeatures();
  portfolios.value = await featureStore.featurePoolMirrorCampaigns();
});

const usedSlots = (portfolio: any) => {
  const used = portfolio.data.filter((item: any) => item.priority === 1).length;
  return `${used} / ${portfolio.campaign.max_slots}`;
};

const remainingDaysTooltip = (portfolio) => {
  const remainingDays = poolmirrorStore.remainingDays(portfolio.campaign.enddate);
  const remainingDaysPercentage = poolmirrorStore.remainingDaysPercentage(portfolio.campaign);

  return remainingDaysPercentage <= 0
    ? translator.get('portfolio.subscription_ended') + ' ' + remainingDays
    : translator.get('portfolio.subscription_ends_in') + ' ' + remainingDays;
};
</script>

<style scoped lang="scss">
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
}
</style>
